import { z } from 'zod';
import { PaymentOrganizationSchema } from '../fulfillment/post-order-fulfill.ts';
import { PRODUCT_CATEGORY_SCHEMA } from '../order-product/product-category.ts';
import { SUPPORTED_UNITS_SCHEMA } from '../quote-unit/unit-types.ts';
import { CustomisedQuotePayloadByProductTypeSchema } from '../quote/quote-payload.ts';
import { PRODUCT_TYPE_SCHEMA } from '../product-type/product-types.ts';

export const PostDirectFulfillmentUrlSchema = z.object({
    positionId: z.string().uuid(),
});

const SharedProductFields = z.object({
    productType: PRODUCT_TYPE_SCHEMA,
    amount: z.number(),
    serviceDate: z.coerce.date(),
    paymentOrganizations: z.array(PaymentOrganizationSchema),
    quotePayload: CustomisedQuotePayloadByProductTypeSchema,
    orderingOrganizationId: z.number(),
    partnerOrganizationId: z.number(),
    platformOrganizationId: z.number(),
    unit: SUPPORTED_UNITS_SCHEMA,
    currencyCode: z.string().length(3),
    salesTaxClassId: z.string(),
    salesPrice: z.number(),
    purchasePrice: z.number(),
    purchaseTaxClassId: z.string(),
    showZeroSalesPrice: z.boolean(),
    showZeroPurchasePrice: z.boolean(),
});

const NewProductSchema = z
    .object({
        isNewProduct: z.literal(true),
        name: z.string(),
        index: z.number().positive(),
        productId: z.string().uuid(),
        category: PRODUCT_CATEGORY_SCHEMA,
    })
    .merge(SharedProductFields);

const ExistingProductSchema = z
    .object({
        isNewProduct: z.literal(false),
        positionProductId: z.string().uuid(),
    })
    .merge(SharedProductFields);

export const PostDirectFulfillmentRequestSchema = z.array(
    z.discriminatedUnion('isNewProduct', [NewProductSchema, ExistingProductSchema])
);

export const PostDirectFulfillmentResponseSchema = z.object({
    orderId: z.string().uuid(),
    products: z.array(
        z.object({
            id: z.string().uuid(),
            quoteId: z.string().uuid(),
            positionProductId: z.string().uuid().nullable(),
        })
    ),
});
